__turbopack_context__.v({
  "boostedText": "styles-module__e0GCEW__boostedText",
  "container": "styles-module__e0GCEW__container",
  "pillsContainer": "styles-module__e0GCEW__pillsContainer",
});
